export default __webpack_public_path__ + "static/media/AlphaGreenLogo.33e25784.png";